import React, { useEffect, useState } from "react";
import { Modal, Grid, Typography, Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";

const Question = ({
  classes,
  question,
  index,
  selected,
  setSelected,
  anySelected,
  questionIndex,
}) => {
  useEffect(() => {
    selected > 0 && setHover(false);
  }, [selected]);

  const [hover, setHover] = useState(false);
  return (
    <Grid container className={classes.mainContainer}>
      <Typography className={questionIndex === 3 ? classes.q3Year : classes.year} dangerouslySetInnerHTML={{ __html: question.name }}>
        {/* {question.name} */}
        {/* {question.yearWithText ? question.yearWithText : question.year} */}
      </Typography>

      <Grid
        className={classes.imageConatiner}
        style={{ border: selected ? "5px solid #00b1d9" : "5px solid #3b8596" }}
        onMouseOver={(e) => !selected && setHover(true)}
        onMouseLeave={(e) => setHover(false)}
        onClick={() => setSelected(index)}
      >
        <img src={question.image} className={classes.image} />
        {/* <Grid
          container
          className={classes.tagContainer}
          style={{ background: selected ? "#00b1d9" : "#003e4c" }}
        >
          <Typography className={classes.tagText}>${question.price}</Typography>
        </Grid> */}
        {hover ? (
          <Grid className={classes.opcityContainer}></Grid>
        ) : (
          anySelected &&
          !selected && <Grid className={classes.opcityGreyContainer}></Grid>
        )}
      </Grid>
      {/* <Grid className={classes.priceCpiContainer}>
        <Typography
          variant="h5"
          align="center"
          className={classes.priceCpiText}
        >
          Price:{" "}
          <span
            className={`${classes.text} animate__animated animate__bounceIn`}
          >
            ${question.price}
            {question.asteric}
          </span>
        </Typography>

        <Typography
          variant="h5"
          align="center"
          className={classes.priceCpiText}
        >
          CPI:{" "}
          <span
            className={`${classes.text} animate__animated animate__bounceIn`}
          >
            {question.cpi}
          </span>
        </Typography>
      </Grid> */}
    </Grid>
  );
};

export default withStyles(styles)(Question);
